import React from 'react';
import { PROFILE } from '../data/profile';
type PortraitFrameProps = {
  tone?: 'light' | 'dark';
  size?: 'md' | 'lg';
  showCaption?: boolean;
};
export function PortraitFrame({
  tone = 'dark',
  size = 'lg',
  showCaption = true
}: PortraitFrameProps) {
  const isDark = tone === 'dark';
  const width = size === 'lg' ? 'w-[280px] sm:w-[340px]' : 'w-[220px] sm:w-[260px]';
  return <figure className={['relative mx-auto', width].join(' ')} data-id="element-251" data-mp="2i6y20vxxbmd7">
      {/* Outer gold rule */}
      <div aria-hidden="true" className="absolute -inset-4 border border-gold-500/50 sm:-inset-5" data-id="element-252" data-mp="2d8efouff48kb" />
      {/* Corner ornaments */}
      {['-top-4 -left-4 border-t-2 border-l-2 sm:-top-5 sm:-left-5', '-top-4 -right-4 border-t-2 border-r-2 sm:-top-5 sm:-right-5', '-bottom-4 -left-4 border-b-2 border-l-2 sm:-bottom-5 sm:-left-5', '-bottom-4 -right-4 border-b-2 border-r-2 sm:-bottom-5 sm:-right-5'].map(pos => <span key={pos} aria-hidden="true" className={`absolute h-7 w-7 border-gold-500 sm:h-9 sm:w-9 ${pos}`} data-id="element-253" data-mp="2w55v2srua3j3" />)}

      {/* Mat + image */}
      <div className={['relative p-2.5', isDark ? 'bg-navy-800 shadow-[0_30px_60px_-30px_rgba(0,0,0,0.8)]' : 'bg-navy-900'].join(' ')} data-id="element-254" data-mp="1shgri1sww9bn">
        <div className="border border-gold-500/70 p-1.5" data-id="element-255" data-mp="1iqvxkro6nsz2">
          <div className="relative overflow-hidden" data-id="element-256" data-mp="14s619e96txbr">
            <img src={PROFILE.portrait} alt="Portrait of Gerry Holmes, CPA" className="aspect-square w-full object-cover" data-id="element-257" data-mp="14re4w17rnvkf" />
            <span aria-hidden="true" className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-navy-950/20" data-id="element-258" data-mp="uvt6se5tjffy" />
          </div>
        </div>
      </div>

      {showCaption ? <figcaption className="relative mt-8 text-center" data-id="element-259" data-mp="2p6g1bl959j5y">
          <span aria-hidden="true" className="mx-auto block h-8 w-px bg-gold-500/60" data-id="element-260" data-mp="2u6kmhokzz22i" />
          <span className={['mt-6 flex items-center justify-center gap-3 text-[10px] uppercase tracking-widest', isDark ? 'text-gold-400' : 'text-gold-600'].join(' ')} data-id="element-261" data-mp="2ss1dg4shjczy">
            <span className="h-px w-6 bg-gold-500/60" aria-hidden="true" data-id="element-262" data-mp="2dt7dwiny2rrw" />
            Est. Career 2003
            <span className="h-px w-6 bg-gold-500/60" aria-hidden="true" data-id="element-263" data-mp="3bgy66488hxg2" />
          </span>
          <h1 className={['mt-5 font-serif text-3xl leading-tight sm:text-[42px]', isDark ? 'text-white' : 'text-navy-900'].join(' ')} data-id="element-264" data-mp="36hv3gqfq83b9">
            Gerry Holmes, <span className="text-gold-400" data-id="element-265" data-mp="2wsbm5p7nwhii">CPA</span>
          </h1>
          <p className={['mx-auto mt-5 max-w-xl font-serif text-base leading-relaxed sm:text-lg', isDark ? 'text-slateink-100' : 'text-slateink-600'].join(' ')} data-id="element-266" data-mp="2wpz1336lxr18">
            Global Finance Executive
            <span className="mx-2 text-gold-500/70" aria-hidden="true" data-id="element-267" data-mp="1lagqgv2g9am">
              |
            </span>
            Board Member &amp; Audit Committee Candidate
            <span className="mx-2 text-gold-500/70" aria-hidden="true" data-id="element-268" data-mp="ak4b00kxcnl0">
              |
            </span>
            US Head of Finance, Bank of Ireland
          </p>
        </figcaption> : null}
    </figure>;
}